import React from "react"
import styled from "styled-components"
import { format, getDay } from 'date-fns';

import { Card } from '../../../../components/ui-parts/Card';
import { SchedulableTime } from "./SchedulableTime"
import {
  SchedulableTime as SchedulableTimeModel,
} from "./types"

const weekDay = ['(日)', '（月)', '(火)', '(水)', '(木)', '(金)', '(土)']

type Props = {
  date: Date
  schedulableTimes: SchedulableTimeModel[]
  onChange: () => void
  facilityId: string
  meetingType: string
  chooseSchedule: (chosenSchedule: SchedulableTimeModel) => void
  onClick: () => void
  primaryColor: string
}

const SchedulesTimesWrap = styled.ul`
  margin-block-start: 1em;
  margin-block-end: 1em;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
  padding: 0 24px;
  @media screen and (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 767px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media screen and (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

export const SchedulableTimes: React.FC<Props> = (props) => {
  const { date, schedulableTimes, facilityId, meetingType } = props

  return (
    <Card compact={true} align="left" color="teal" title={`${format(date, "yyyy/MM/dd")} ${weekDay[getDay(date)]}`} primaryColor={props.primaryColor}>
      <SchedulesTimesWrap>
        {schedulableTimes.map((schedulableTime) => (
          <SchedulableTime
            key={schedulableTime.startAt.toISOString()}
            schedulableTime={schedulableTime}
            onChange={props.onChange}
            onClick={props.onClick}
            facilityId={facilityId}
            meetingType={meetingType}
            chooseSchedule={props.chooseSchedule}
            primaryColor={props.primaryColor}
          />
        ))}
      </SchedulesTimesWrap>
    </Card>
  )
}
